.building-image{background-position:center bottom;background-image:url(/assets/images/building.png);background-repeat:no-repeat;min-height:150px}
/*# sourceMappingURL=location-energy-compass.component-ITD2BH7M.css.map */
